<template>
  <section class="section-base section">
    <v-container>
      <v-row>
        <v-col>
          <div class="section-base__title">Нотариальные действия</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
          v-for="card in visibleCards"
          :key="card.title"
          class="d-flex"
        >
          <NotariusActionCard
            :statement-type="card.statementType"
            :title="card.title"
            :text="card.text"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-btn
              color="primary"
              v-if="!more"
              @click="more = true"
              class="button-base"
              >Показать еще
            </v-btn>
            <v-btn
              color="primary"
              v-else
              @click="more = false"
              class="button-base"
              >Свернуть
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mdiPlaylistPlus } from '@mdi/js';

import { RouteName } from '@/router';
import { StatementType } from '@/types/services';
import NotariusActionCard from '@/components/Home/sections/NotariusActionCard';
import { statementTypeToNAEnabled } from '@/app.config';
// import { AuthModule } from '@/store/modules/auth';
// import { Role } from '@/utils/dictionaries';

export default {
  name: 'NotariusAction',
  components: {
    NotariusActionCard,
  },
  data() {
    return {
      RouteName,
      StatementType,
      mdiPlaylistPlus,
      more: false,
      cards: [
        {
          statementType: StatementType.NOTICE_RECOVERY,
          title:
            'Совершение удаленно исполнительной надписи о взыскании денежных сумм или истребовании имущества от должника',
          text:
            'Получить исполнительную надпись в формате электронного документа на взыскание денежных сумм или истребование имущества от должника',
        },
        {
          statementType: StatementType.RUZDI,
          title:
            'Выдача выписки из реестра уведомлений о залоге движимого имущества удаленно',
          text:
            'Получить в электронном виде выписку из реестра уведомлений о залоге движимого имущества. Выписка является юридически значимым документом, подтверждающим наличие или отсутствие в залоге имущества, указанного в запросе',
        },
        {
          statementType: StatementType.SECURING_EVIDENCE,
          title: 'Обеспечение доказательств удаленно',
          text:
            'Получить в электронном виде протокол осмотра нотариусом интернет-страницы (или интернет-сайта) с приложением всех необходимых материалов, являющихся доказательствами факта правонарушения',
        },
        {
          statementType: StatementType.ACCEPTANCE_DEPOSIT,
          title:
            'Совершение удаленно нотариального действия по принятию в депозит нотариуса безналичных денежных средств с целью исполнения обязательства',
          text:
            'Направить в электронном виде заявление о совершении удаленно нотариального действия по принятию в депозит нотариуса безналичных денежных средств с целью исполнения обязательства и получить в электронном виде распоряжение о принятии денежных средств на публичный депозитный счет, содержащий реквизиты публичного депозитного счета нотариуса',
        },
        {
          statementType: StatementType.TRANSFER_EL_DOCS,
          title:
            'Передача электронных документов физических и юридических лиц другим физическим и юридическим лицам, совершаемая удаленно',
          text:
            'Получить в электронном виде свидетельство о направлении/передаче нотариусом электронного документа (пакета электронных документов) лицу, указанному в заявлении',
        },
        {
          statementType: StatementType.DOCUMENT_CONVERSION,
          title:
            'Конвертация электронного документа из одного формата в другой с сохранением его юридической силы',
          text:
            'Направить в электронном виде заявление об удостоверении равнозначности электронного документа, изготовленного нотариусом путем преобразования представленного нотариусу электронного документа посредством изменения его формата (конвертации), для подтверждения тождественности содержания изготовленного нотариусом путем конвертации электронного документа содержанию представленного нотариусу электронного документа.',
        },
        {
          statementType: StatementType.CORRECT_TRANSLATION,
          title:
            'Свидетельствование верности перевода нотариусом, совершенного удаленно',
          text:
            'Получить в электронном виде изготовленный нотариусом перевод с удостоверительной надписью о свидетельствовании верности перевода, сделанного нотариусом',
        },
        {
          statementType: StatementType.STORAGE_ACCEPT,
          title:
            'Принятие на хранение электронного документа (пакета электронных документов) удаленно',
          text:
            'Передать на хранение нотариусу электронный документ и получить в электронном виде свидетельство о принятии на хранение электронного документа (пакета электронных документов), подписанное квалифицированной электронной подписью нотариуса и содержащее идентификатор хранилища электронного документа (пакета электронных документов).',
        },
        {
          statementType: StatementType.STORAGE_ISSUE,
          title:
            'Выдача принятого на хранение электронного документа (пакета электронных документов) удаленно',
          text:
            'Направить в электронном виде заявление о выдаче электронного документа (пакета электронных документов), принятого на хранение, подписанное квалифицированной электронной подписью и содержащее идентификатор хранилища электронного документа (пакета электронных документов) в электронном виде.',
        },
        {
          statementType: StatementType.ACCEPTANCE_ESCROW,
          title:
            'Принятие на депонирование безналичных денежных средств удаленно для расчета по сделкам',
          text:
            'Направить в электронном виде заявление о принятии от должника на депонирование безналичных денежных средств в целях их передачи кредитору в порядке, в сроки и на условиях, которые указаны в заявлении.',
        },
        {
          statementType: StatementType.ROD,
          title:
            'Регистрация распоряжения об отмене доверенностей, за исключением нотариально удостоверенных доверенностей',
          text:
            'Направить в электронной форме распоряжение об отмене доверенностей, за исключением нотариально удостоверенных доверенностей для регистрации в реестре распоряжений об отмене доверенностей.',
        },
        {
          statementType: StatementType.EXTRACTION_ROD,
          title:
            'Выдача выписки из реестра распоряжений об отмене доверенностей, за исключением нотариально удостоверенных доверенностей',
          text:
            'Получить в электронном виде выписку из реестра распоряжений об отмене доверенностей, за исключением нотариально удостоверенных доверенностей.',
        },
        {
          statementType: StatementType.EGRN_CONFIRM,
          title:
            'Удостоверение удаленно факта наличия сведений в Едином государственном реестре недвижимости',
          text:
            'Получить в электронном виде выписку и свидетельство из Единого государственного реестра недвижимости.',
        },
      ],
    };
  },
  computed: {
    filteredCards() {
      return this.cards.filter((na) => {
        // if (
        //   na.statementType === StatementType.NOTICE_RECOVERY &&
        //   AuthModule.roleType === Role.PERSON &&
        //   !AuthModule.isBusinessman
        // ) {
        //   return false;
        // }

        return statementTypeToNAEnabled[na.statementType];
      });
    },

    visibleCards() {
      return this.more ? this.filteredCards : this.filteredCards.slice(0, 3);
    },
  },
};
</script>

<style scoped lang="scss">
.section {
  padding-bottom: 70px;
}

.all-button {
  margin: 0 auto;
}
</style>
